import { render, staticRenderFns } from "./JiandangDetail.vue?vue&type=template&id=07803d6d&scoped=true&"
import script from "./JiandangDetail.vue?vue&type=script&lang=js&"
export * from "./JiandangDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiandangDetail.vue?vue&type=style&index=0&id=07803d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07803d6d",
  null
  
)

export default component.exports